import api from "api/api";
import { cleanUrlV2 } from "utils/helper";

export const createMissionBillQuery = async ({ data, userScope }) =>
  await api.post(`/mission-bill?scope=${userScope}`, data);

export const getMissionBillByMissionIdQuery = async ({ id, userScope }) =>
  await api.get(`/mission-bill/mission/${id}?scope=${userScope}`);

export const bulkEditMissionBillQuery = async ({ data, userScope }) =>
  await api.put(`/mission-bill/bulk-edit?scope=${userScope}`, data);

export const searchMissionBillsByParametersQuery = async ({
  filters,
  scope,
}) => {
  const queryString = cleanUrlV2(filters);
  return await api.get(`/mission-bill/search?scope=${scope}&${queryString}`);
};

export const importExcelFacturationsQuery = async ({
  data,
  setProgression,
  userScope,
}) =>
  await api.putFile(`/mission-bill/import?scope=${userScope}`, data, {
    onUploadProgress: (event) => {
      if (event.total) {
        const percentComplete = (event.loaded / event.total) * 100;
        setProgression(percentComplete.toFixed());
      }
    },
  });
